export default __webpack_public_path__ + "static/media/instituto-neurologico-veterinario.fb9c5d07.jpg";